<template>
  <div class="wrapper">
    <public-title jurisdictionname="权限名" jurisdictionType="权限类别搜索"  @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
  <el-table
    :data="tabledata"
    style="width: 100%;margin-bottom: 20px;"
    row-key="id"
    border
    :tree-props="{children: 'childrens', hasChildren: 'children'}"
    :default-expand-all="true"
    >
    <el-table-column
      prop="name"
      label="权限名称"
     >
    </el-table-column>
    <el-table-column
      prop="code"
      label="权限编码"
      >
    </el-table-column>
    <el-table-column
      prop="iconPath"
      label="图标">
      <template slot-scope="scope">
        <i :class="scope.row.iconPath"></i>
      </template>
    </el-table-column>
    <el-table-column
      label="权限类别">
      <template slot-scope="scope">
        {{type(scope.row.type)}}
      </template>
    </el-table-column>
    <el-table-column
      prop="urlPath"
      label="路径">
    </el-table-column>

    <el-table-column label="操作" width="250" align="center">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
        <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
          @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
          title="您确定要删除这一条记录吗？"> -->
          <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        <!-- </el-popconfirm> -->
      </template>
    </el-table-column>
  </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>

    <el-dialog :title="issubbtn?'新增权限':'修改权限'" :before-close="handleClose" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="subform" :rules="rules" label-width="80px">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="subform.name"></el-input>
        </el-form-item>

        <el-form-item label="权限编码" prop="code">
          <el-input v-model="subform.code"></el-input>
        </el-form-item>

        <el-form-item label="图标" prop="iconPath">
          <el-input v-model="subform.iconPath"></el-input>
        </el-form-item>

        <el-form-item label="权限类别" prop="type">
          <el-select v-model="subform.type" clearable filterable style="width: 100%;" placeholder="请选择">
            <el-option
              v-for="item in dictionariesStatesArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="路径" prop="urlPath">
          <el-input v-model="subform.urlPath"></el-input>
        </el-form-item>


        <el-form-item label="父节点" prop="pid">
          <el-select v-model="subform.pid" clearable filterable style="width: 100%;" placeholder="请选择">
            <el-option
              v-for="item in fathernodearr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>





        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="subform.sort"></el-input>
        </el-form-item>



        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        dictionariesStatesArr: [{
          value: '0',
          label: '菜单'
        }, {
          value: '1',
          label: '按钮'
        }],
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          code:'',//权限编码
          iconPath:'',//	图标
          name:'',//	权限名称
          pid:'',//	父节点id
          sort:'',//排序
          type:'',//	类型
          urlPath:'',//	路径
        },
        DelVisible: false,
        dialogVisible: false,
        rules: {
          code: [
            { required: true, message: '请输入权限编码', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择类型', trigger: ['blur', 'change']  },
          ],
          name: [
            { required: true, message: '请输入权限名称', trigger:  ['blur', 'change']  },
          ],
          urlPath: [
            { required: true, message: '请输入路径', trigger:  ['blur', 'change']  },
          ],
          sort: [
            { required: true ,  message: '请输入排序',trigger:   ['blur', 'change']  },
            { type: 'number', message: '年龄必须为数字值'}
          ],
        },
        issubbtn:false, // edit fals - add true
        id:'',
        fathernodearr:[],
      };
    },
    computed: {
      type(val){
        return (val)=>{
          if(val == 0){
            return '菜单'
          }else{
            return '按钮'
          }
        }
      }
    },
    mounted() {
      this.updata()
    },
    methods: {
      fathernode(){
        this.$http({
          url: this.$api.permissionlist,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data)
            this.fathernodearr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      updata(pageIndex = 1, pageSize = 15, Vjurisdictionname = '', VjurisdictionType = '') {
        this.$http({
          url: this.$api.permissiontree + `?pageIndex=${pageIndex}&pageSize=${pageSize}&name=${Vjurisdictionname}&type=${VjurisdictionType}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data)
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vjurisdictionname, this.form.VjurisdictionType)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vjurisdictionname, this.form.VjurisdictionType)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vjurisdictionname, this.form.VjurisdictionType)
      },
      edit(index, item) {
        this.fathernode()
        this.dialogVisible = true;
        this.issubbtn = false
        this.id = item.id
        console.log(item)
        this.subform.code = item.code
        this.subform.iconPath =item.iconPath
        this.subform.name = item.name
        if(item.pid==0){
          this.subform.pid = ''
        }else{
          this.subform.pid = item.pid
        }
        this.subform.sort = item.sort
        this.subform.type = item.type.toString()
        this.subform.urlPath = item.urlPath
      },
      btn(){
        this.subform.code = ''
        this.subform.iconPath = ''
        this.subform.name = ''
          this.subform.pid = ''
        this.subform.sort = ''
        this.subform.type = ''
        this.subform.urlPath = ''

        console.log(this.subform)
        this.fathernode()
        this.dialogVisible = true
        this.subform.name = ''
        this.issubbtn = true
      },
      //删除
      handleDelete(index, item) {
        this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.permissiondel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize , this.form.Vjurisdictionname, this.form.VjurisdictionType)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      onSubmit(formName) {
        console.log(this.subform)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,
                code:this.subform.code,//权限编码
                iconPath:this.subform.iconPath,//	图标
                name:this.subform.name,//	权限名称
                pid:this.subform.pid,//	父节点id
                sort:this.subform.sort,//排序
                type:this.subform.type,//	类型
                urlPath:this.subform.urlPath,//	路径
              }
              this.$http({
                url: this.$api.permissionsave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize,  this.form.Vjurisdictionname, this.form.VjurisdictionType)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                userId,
                id:this.id,//权限id
                code:this.subform.code,//权限编码
                iconPath:this.subform.iconPath,//	图标
                name:this.subform.name,//	权限名称
                pid:this.subform.pid,//	父节点id
                sort:this.subform.sort,//排序
                type:this.subform.type,//	类型
                urlPath:this.subform.urlPath,//	路径
              }
              this.$http({
                url: this.$api.permissionupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vjurisdictionname, this.form.VjurisdictionType)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
        this.subform.code = ''
        this.subform.iconPath = ''
        this.subform.name =  ''
        this.subform.pid =  ''
        this.subform.sort =  ''
        this.subform.type =  ''
        this.subform.urlPath = ''
      },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 100%;
   
  }

  /deep/.el-pagination {
    text-align: center;
    padding: 10px 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
    .wrapper{
    height: 100%;

  }
  /deep/.el-table{
      // overflow-x: scroll;
}
/deep/.el-table th>.cell{
  color: #000;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{
  height:63vh;
   padding-bottom: 5%!important;
  overflow-y: auto;
}
</style>